const isAccountInactive = (currentAccount) => currentAccount.activo === false

const isMyProductsSectionHidden = (currentAccount, isFullView) => {
  if (!isFullView && isAccountInactive(currentAccount)) return true
  return !currentAccount.mostrarSeccionMisProductos || isFullView
}

const isMyOrdersSectionHidden = (currentAccount, isFullView) => {
  if (!isFullView && isAccountInactive(currentAccount)) return true
  return !currentAccount.mostrarSeccionMisPedidos
}

const isMyProvidersSectionHidden = (currentAccount, isFullView) => {
  if (!isFullView && isAccountInactive(currentAccount)) return true
  return !!currentAccount.securityFlags ? !currentAccount.securityFlags.showSectionMyProviders : true
}

const isIncidencesSectionHidden = (currentAccount, isFullView) => {
  if (!isFullView && isAccountInactive(currentAccount)) return true
  return !currentAccount.mostrarSeccionIncidencias
}

const isMyFinancesSectionHidden = (currentAccount, isFullView) => {
  if (!isFullView && isAccountInactive(currentAccount)) return true
  return (!!currentAccount.securityFlags ? !currentAccount.securityFlags.showSectionMyFinances : true) ||
    !isFullView
}

const isMyInvoicesAndPaymentsSectionHidden = (currentAccount, _) =>
  !currentAccount.mostrarSeccionMisFacturasAbonos

const isMyOrderAndDeliveryDaysSectionHidden = (currentAccount, isFullView) => {
  if (!isFullView && isAccountInactive(currentAccount)) return true
  return !currentAccount.mostrarSeccionMisDiasDePedidoEntrega || isFullView
}

const isInformationSectionHidden = (currentAccount, isFullView) => {
  if (!isFullView && isAccountInactive(currentAccount)) return true
  return !currentAccount.mostrarSeccionInformacion || isFullView
}

const isMyAccountSectionHidden = (currentAccount, isFullView) =>
  !currentAccount.mostrarSeccionMiCuenta || isFullView

const isHelpSectionHidden = (currentAccount, _) => !currentAccount.mostrarSeccionAyuda

const isVendor = (currentAccount, isFullView) => {
  if (!isFullView && isAccountInactive(currentAccount)) return true 
  return !currentAccount.securityFlags || !currentAccount.securityFlags.isVendor
}


let items = [
  {
    name: 'Resumen',
    class: 'nav-overview',
    url: '/accountdashboard',
    icon: 'cui-speedometer',
    isHidden: () => false
  },

  {
    name: 'Mis productos',
    class: 'nav-my-products-section d-none',
    title: true,
    isHidden: isMyProductsSectionHidden
  },
  {
    name: 'Webshop',
    class: 'nav-my-products-section__webshop',
    url: '/catalog',
    icon: 'icon-bag',
    isHidden: isMyProductsSectionHidden
  },
  {
    name: 'Plantillas',
    class: 'nav-my-products-section__templates',
    url: '/ordertemplate',
    icon: 'cui-list',
    isHidden: isMyProductsSectionHidden
  },
  {
    name: 'Promociones',
    class: 'nav-my-products-section__promotions',
    url: '/promotions',
    icon: 'icon-tag',
    isHidden: (currentAccount, isFullView) =>
      isMyProductsSectionHidden(currentAccount, isFullView) || !currentAccount.urlPromociones
  },
  {
    name: 'Cat\u00E1logo',
    class: 'nav-my-products-section__brochure',
    url: '/brochure',
    icon: 'icon-book-open',
    isHidden: (currentAccount, isFullView) =>
      isMyProductsSectionHidden(currentAccount, isFullView) || !currentAccount.urlFolleto
  },
  {
    name: 'Planograma',
    class: 'nav-my-products-section__planogram',
    url: '/planogram',
    icon: 'icon-map',
    isHidden: (currentAccount) => !currentAccount.urlPlanogramas
  },
  {
    name: 'Mis Pedidos',
    class: 'nav-my-orders-section d-none',
    title: true,
    isHidden: isMyOrdersSectionHidden
  },
  {
    name: 'Listado',
    class: 'nav-my-orders-section__list',
    url: '/order',
    icon: 'cui-clipboard',
    isHidden: isMyOrdersSectionHidden
  },
  {
    name: 'Enviados a Conway',
    class: 'nav-my-orders-section__list',
    url: '/orders/temporal',
    icon: 'cui-clipboard',
    isHidden: isMyOrdersSectionHidden
  },
  {
    name: 'Mis proveedores',
    class: 'nav-my-providers-section d-none',
    title: true,
    isHidden: isMyProvidersSectionHidden
  },
  {
    name: 'Listado',
    class: 'nav-my-providers-section__providers',
    url: '/providers',
    icon: 'icon-social-dropbox',
    isHidden: isMyProvidersSectionHidden
  },
  {
    name: 'Stocks',
    class: 'nav-my-providers-section__stocks',
    url: '/stocks',
    icon: 'icon-graph',
    isHidden: (currentAccount, _) =>
      isMyProvidersSectionHidden(currentAccount, _) || !currentAccount.mostrarStocks
  },
  {
    name: 'Reportes',
    class: 'nav-my-providers-section__reports',
    url: '/providerreports',
    icon: 'icon-docs',
    isHidden: isMyProvidersSectionHidden
  },
  {
    name: 'Surtido',
    class: 'nav-my-providers-section__assortment',
    url: '/assortment',
    icon: 'icon-bag',
    isHidden: isMyProvidersSectionHidden
  },
  {
    name: 'Incidencias IRP',
    class: 'nav-my-providers-section__irp_incidences',
    url: '/irpincidences',
    icon: 'fa fa-exclamation-triangle',
    isHidden: isMyProvidersSectionHidden
  },
  {
    name: 'Incidencias de no conformidad',
    class: 'nav-my-providers-section__non_conformity_incidences',
    url: '/nonconformityincidences',
    icon: 'fa fa-exclamation-triangle',
    isHidden: isMyProvidersSectionHidden
  },

  {
    name: 'Incidencias ',
    class: 'nav-incidences-section d-none',
    title: true,
    isHidden: isIncidencesSectionHidden
  },
  {
    name: 'Incidencias y consultas',
    class: 'nav-incidences-section__service',
    url: '/incidences',
    icon: 'icon-layers',
    isHidden: isIncidencesSectionHidden
  },

  {
    name: 'Mis finanzas',
    class: 'nav-my-finances-section d-none',
    title: true,
    isHidden: isMyFinancesSectionHidden
  },
  {
    name: 'Condiciones de pago y saldo pendiente',
    class: 'nav-my-finances-section__balances',
    url: '/balances',
    icon: 'fa fa-balance-scale',
    isHidden: isMyFinancesSectionHidden
  },
  {
    name: 'Recibos emitidos',
    class: 'nav-my-finances-section__receipts',
    url: '/receipts',
    icon: 'fa fa-money',
    isHidden: isMyFinancesSectionHidden
  },
  {
    name: 'M347',
    class: 'nav-my-finances-section__m347',
    url: '/m347',
    icon: 'fa fa-file-text-o',
    isHidden: isMyFinancesSectionHidden
  },

  {
    name: 'Mis facturas y abonos',
    class: 'nav-my-invoices-payments-section d-none',
    title: true,
    isHidden: isMyInvoicesAndPaymentsSectionHidden
  },
  {
    name: 'Listado',
    class: 'nav-my-invoices-payments-section__list',
    url: '/documents',
    icon: 'fa fa-newspaper',
    isHidden: isMyInvoicesAndPaymentsSectionHidden
  },
  {
    name: 'Mis d\u00EDas de pedido y entrega',
    class: 'nav-my-order-delivery-days-section d-none',
    title: true,
    isHidden: isMyOrderAndDeliveryDaysSectionHidden
  },
  {
    name: 'Mis d\u00EDas de pedido y entrega',
    class: 'nav-my-order-delivery-days-section__list',
    url: '/routes',
    icon: 'icon-calendar',
    isHidden: isMyOrderAndDeliveryDaysSectionHidden
  },
  {
    name: 'Mis visitas',
    class: 'nav-vendor-section d-none',
    title: true,
    isHidden: isVendor
  },
  {
    name: 'Config. Visitas',
    class: 'nav-vendor-section__list',
    url: '/appointments-configuration',
    icon: 'icon-calendar',
    isHidden: isVendor
  },
  {
    name: 'Visitas',
    class: 'nav-vendor-section__list',
    url: '/routes-vendor',
    icon: 'icon-calendar',
    isHidden: isVendor
  },
  {
    name: 'Informaci\u00F3n',
    class: 'nav-information-section d-none',
    title: true,
    isHidden: isInformationSectionHidden
  },
  {
    name: 'Reportes',
    class: 'nav-information-section__reports',
    url: '/reporting',
    icon: 'icon-docs',
    isHidden: isInformationSectionHidden
  },
  {
    name: 'Manuales operativos',
    class: 'nav-information-section__manuals',
    url: '/Files',
    icon: 'icon-docs',
    isHidden: isInformationSectionHidden
  },
  {
    name: 'Informaci\u00F3n de inter\u00E9s',
    class: 'nav-information-section__interest',
    url: '/Links',
    icon: 'icon-globe',
    isHidden: isInformationSectionHidden
  },

  {
    name: 'Mis Reportes',
    class: 'nav-my-reports-section d-none',
    title: true
  },

  {
    name: 'Mi Cuenta',
    class: 'nav-my-account-section d-none',
    title: true,
    isHidden: isMyAccountSectionHidden
  },
  {
    name: 'Datos',
    class: 'nav-my-account-section__interest',
    url: '/account',
    icon: 'cui-briefcase',
    isHidden: isMyAccountSectionHidden
  },
  {
    name: 'Seleccionar punto de venta',
    class: 'nav-my-account-section__selling-points',
    url: '/accountchange',
    icon: 'fa fa-refresh',
    isHidden: isMyAccountSectionHidden
  },

  {
    name: 'Ayuda',
    class: 'nav-help-section d-none',
    title: true,
    isHidden: isHelpSectionHidden
  },
  {
    name: 'Preguntas frecuentes',
    class: 'nav-help-section__faq',
    url: '/faq',
    icon: 'icon-directions',
    isHidden: isHelpSectionHidden
  },
  {
    name: 'Contacta con nosotros',
    class: 'nav-help-section__contact',
    url: '/contact',
    icon: 'icon-bubbles',
    isHidden: isHelpSectionHidden
  }
]

items.forEach((item) => {
  if (!item.title && !item.attributes) {
    item['attributes'] = { hidden: true }
  }
})

export default { items }
